import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import ModalManager from '@ebay/nice-modal-react';
import cn from 'classnames';

import { PlusIcon } from 'public/icons';

import * as dealResource from 'resources/deal/hooks';

import Button from 'UI/Button';
import AddNewClientModal from 'modals/AddNewClientModal';

import styles from './styles.module.scss';

const NewClientButton = ({
  iconBefore,
  label,
  className,
  selectedRealtorId,
  withoutRedirect,
  onAfterAdd,
  ...props
}) => {
  const router = useRouter();
  const { onClick, ...otherProps } = props;

  // try to get realtor id from deal, if we add client to transaction directly
  const { id: dealId } = router.query;
  const { data: deal } = dealResource.useDealById(dealId, { enabled: !!dealId });

  const handleAddNewClientClick = useCallback(() => {
    ModalManager.show(AddNewClientModal, {
      withoutRedirect,
      selectedRealtorId: deal?.realtor_id || selectedRealtorId,
      onAfterAdd,
    });

    onClick?.();
  }, [withoutRedirect, deal, selectedRealtorId, onAfterAdd, onClick]);

  return (
    <Button
      type="default"
      className={cn(styles.button, className)}
      onClick={handleAddNewClientClick}
      iconBefore={iconBefore}
      {...otherProps}
    >
      {label}
    </Button>
  );
};

NewClientButton.propTypes = {
  label: PropTypes.string,
  iconBefore: PropTypes.node,
  className: PropTypes.string,
  selectedRealtorId: PropTypes.string,
  withoutRedirect: PropTypes.bool,
  onAfterAdd: PropTypes.func,
  ...Button.propTypes,
};

NewClientButton.defaultProps = {
  label: 'New client',
  iconBefore: PlusIcon,
  className: null,
  selectedRealtorId: null,
  withoutRedirect: false,
  onAfterAdd: () => {},
};

export default NewClientButton;
